import { api } from "./api";

export const reportsService = {
  summary: async (params) => (await api.get("/admin/reports/summary", { params })).data,

  /**
   * Downloads a CSV endpoint. Uses axios responseType=blob so umlauts and
   * the leading UTF-8 BOM (for Excel) round-trip correctly.
   * @param {"orders"|"products"|"damages"} kind
   * @param {object} params — {from, to, status?}
   */
  downloadCsv: async (kind, params) => {
    const res = await api.get(`/admin/reports/${kind}.csv`, {
      params,
      responseType: "blob",
    });
    // Prefer the server-supplied filename when Content-Disposition is set.
    let filename = `${kind}_${params.from}_${params.to}.csv`;
    const cd = res.headers?.["content-disposition"] || "";
    const m = cd.match(/filename="([^"]+)"/);
    if (m) filename = m[1];
    return { blob: res.data, filename };
  },
};
